import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public visible: boolean;
  public displayLiveStream: boolean = false;
  @Output() variableEvent: EventEmitter<boolean> = new EventEmitter();

  private _aboutUsDropdown: boolean; // about us dropdown toggle
  private _eventUpdateDropdown: boolean; // about us dropdown toggle
  public showMenu: boolean;

  constructor(private dataService: DataService, private route: Router) {
    this._aboutUsDropdown = false;
  }

  ngOnInit() {
    this.showMenu = false;
    this.visible = false;
  }

  public showStreamEvent() {
    this.route.navigate(['/concert'])
    setTimeout(() => {
      this.dataService.sendData(true);
    }, 500);
  }

  onMenuClick(): void {
    // this.document.body.style.overflow = 'hidden';
    this.showMenu = !this.showMenu;
  }

  /**
   * Store the visible state of the About Us Dropdown.
   *
   * @type read-only boolean
   */
  public get aboutUsDropdown(): boolean {
    return this._aboutUsDropdown;
  }

  /**
   * Store the visible state of the Event-Update Dropdown.
   *
   * @type read-only boolean
   */
  public get eventUpdateDropdown(): boolean {
    return this._eventUpdateDropdown;
  }

  /**
   * On Dropdown Hover Event Function
   *
   * @type void
   * @argument args:event, link: string
   * @return none
   */
  public onAboutUsDropdownHover(args): void {
    this._aboutUsDropdown = args ? true : false;
  }

  /**
 * On Dropdown Hover Event Function
 *
 * @type void
 * @argument args:event, link: string
 * @return none
 */
  public onEventUpdateDropdownHover(args): void {
    this._eventUpdateDropdown = args ? true : false;
  }
}
